import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from '@shopify/polaris'
import InsertWebhookModal from './InsertWebhookModal'
import {insertWebhook} from '../../../services/api/WebhookServices'
import {CirclePlusMajorMonotone} from '@shopify/polaris-icons'

class InsertWebhook extends Component {
    state = {
        toggle: false,
        loading: false,
        message: {
            error: '',
            success: '',
        },
    }

    _toggle = () => {
        if (this.state.loading) return
        this.setState({toggle: !this.state.toggle})
    }

    _save = async webhook => {
        if (this.state.loading) return
        this.setState({loading: true})
        const {success, data, message} = await insertWebhook(webhook)

        if (!success) {
            this.setState({loading: false, message: {error: message || 'Add webhook error.', success: ''}})
            throw new Error(message)
        }
        this.props.insert(data)
        this.setState({loading: false, message: {error: '', success: 'Add webhook successfully.'}}, this._toggle)

        return {success, data, message}
    }

    render() {
        const {toggle, loading, message} = this.state

        return (
            <div className="mr-4 mb-4">
                <Button primary onClick={this._toggle} icon={CirclePlusMajorMonotone}>
                    Add new
                </Button>
                <InsertWebhookModal open={toggle} toggle={this._toggle} save={this._save} loading={loading}
                                    message={message}/>
            </div>
        )
    }
}

InsertWebhook.propTypes = {
    insert: PropTypes.func.isRequired,
}

export default InsertWebhook
